<template>
  <v-card rounded="lg" outlined>
    <v-card-title class="subtitle-1 font-weight-bold">Produtos</v-card-title>
    <v-card-text>
      <btn-adicionar-produto />
      <v-list v-if="isMobile()">
        <v-list-item
          v-for="(prodAdd, i) in getItensPedido()"
          :key="i"
          class="grey lighten-4 mt-1 rounded-lg"
        >
          <template v-if="!prodAdd.somatorio">
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-bold">{{
                prodAdd.produto
              }}</v-list-item-title>
              <v-list-item-subtitle class="subtitle-1"
                ><v-chip small>{{ prodAdd.emb }}</v-chip></v-list-item-subtitle
              >
              <v-list-item-subtitle class="mt-1">
                <p class="mb-1">
                  Comissão(%)<span class="float-right">{{
                    formatarPercentual(prodAdd.comissaoperc)
                  }}</span>
                </p>
                <p class="mb-1">
                  Acréscimo(%)<span class="float-right">{{
                    formatarPercentual(prodAdd.acrescimoperc)
                  }}</span>
                </p>
                <p class="mb-1">
                  Qtde<span class="float-right">{{ prodAdd.qtde }}</span>
                </p>
                <p class="mb-1">
                  Unitário<span class="float-right">{{
                    formatarMoeda(prodAdd.vlrunitcomfrete, 4)
                  }}</span>
                </p>
                <p class="mb-1">
                  Desconto(%)<span class="float-right">{{
                    formatarPercentual(prodAdd.percdesconto)
                  }}</span>
                </p>
                <p class="mb-1">
                  Desconto(R$)<span class="float-right">{{
                    formatarMoeda(prodAdd.valordesconto)
                  }}</span>
                </p>
                <p class="mb-1">
                  Frete<span class="float-right">{{
                    formatarMoeda(
                      prodAdd.valorliqfrete > 0
                        ? prodAdd.valorliqfrete
                        : prodAdd.valorfrete
                    )
                  }}</span>
                </p>
                <p class="mb-3">
                  Valor item<span class="float-right">{{
                    formatarMoeda(prodAdd.valortotalitem)
                  }}</span>
                </p>
                <btn-remover-produto :produto="prodAdd" />
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-bold"
                >Totais</v-list-item-title
              >
              <v-list-item-subtitle>
                <p class="mt-2 body-2 mb-1">
                  <span>Peso Total(Kgs)</span
                  ><span class="float-right font-weight-bold">{{
                    prodAdd.emb
                  }}</span>
                </p>
                <p class="body-2 mb-1">
                  <span>Desconto(R$)</span
                  ><span class="float-right font-weight-bold">{{
                    formatarMoeda(prodAdd.valordesconto)
                  }}</span>
                </p>
                <p class="body-2 mb-1">
                  <span>Frete</span
                  ><span class="float-right font-weight-bold">{{
                    formatarMoeda(
                      prodAdd.valorliqfrete > 0
                        ? prodAdd.valorliqfrete
                        : prodAdd.valorfrete
                    )
                  }}</span>
                </p>
                <p class="mb-1 mt-2 body-2">
                  <span>Valor total</span
                  ><span class="float-right font-weight-bold black--text">{{
                    formatarMoeda(prodAdd.valortotalitem)
                  }}</span>
                </p>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list>
      <v-data-table
        v-else
        :items="getItensPedido()"
        :headers="headers"
        no-data-text="Nenhum produto adicionado"
        hide-default-footer
        :hide-default-header="novopedido.produtos.length == 0"        
        class="mt-2"
        items-per-page="999"
      >
        <template v-slot:[`item.produto`]="{ item }">
          <span :class="classItem(item)">{{ item.produto }}</span>
        </template>
        <template v-slot:[`item.emb`]="{ item }">
          <span :class="classItem(item)">{{ item.emb }}</span>
        </template>

        <template v-slot:[`item.comissaoperc`]="{ item }">
          <span v-if="!item.somatorio">{{
            formatarPercentual(item.comissaoperc)
          }}</span>
        </template>
        <template v-slot:[`item.percdesconto`]="{ item }">
          <span v-if="!item.somatorio">
            {{ formatarPercentual(item.percdesconto) }}</span
          >
        </template>
        <template v-slot:[`item.acrescimoperc`]="{ item }">
          <span v-if="!item.somatorio">{{
            formatarPercentual(item.acrescimoperc)
          }}</span>
        </template>
        <template v-slot:[`item.valordesconto`]="{ item }">
          <span :class="classItem(item)">{{
            formatarMoeda(item.valordesconto)
          }}</span>
        </template>
        <template v-slot:[`item.vlrunitcomfrete`]="{ item }">
          <span v-if="!item.somatorio">{{
            formatarMoeda(item.vlrunitcomfrete, 4)
          }}</span>
        </template>
        <template v-slot:[`item.valorfrete`]="{ item }">
          <span :class="classItem(item)">{{
            formatarMoeda(
              item.valorliqfrete > 0 ? item.valorliqfrete : item.valorfrete
            )
          }}</span>
        </template>
        <template v-slot:[`item.valortotalitem`]="{ item }">
          <span :class="classItem(item)">
            {{ formatarMoeda(item.valortotalitem) }}</span
          >
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <btn-remover-produto v-if="!item.somatorio" :produto="item" />
        </template>
        <template v-slot> </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatPercentual, formatMoeda } from "@/global";
import { mapGetters, mapState } from "vuex";
import BtnAdicionarProduto from "./botoes/BtnAdicionarProduto.vue";
import BtnRemoverProduto from "./botoes/BtnRemoverProduto.vue";
export default {
  components: { BtnAdicionarProduto, BtnRemoverProduto },
  computed: mapState("pedidos", ["novopedido"]),
  data: () => ({
    produtosPedido: [],
    headers: [
      /*{ text: "Gp", value: "gp", },
      { text: "SGp", value: "sgp", },
      { text: "Item", value: "item", },*/
      { text: "Produto", value: "produto" },
      { text: "Emb", value: "emb" },
      { text: "% Comissão", value: "comissaoperc" },
      { text: "% Acrésc", value: "acrescimoperc" },
      { text: "Qtde", value: "qtde" },
      //{ text: "Qtde(kgs)", value: "qtdekgs" },
      { text: "Unitário", value: "vlrunitcomfrete" },
      { text: "% Desc", value: "percdesconto" },
      { text: "Vlr Desc.", value: "valordesconto" },
      { text: "Vlr Frete", value: "valorfrete" },
      { text: "Vlr Total", value: "valortotalitem" },
      { text: "", value: "actions", sortable: false, align: "end" },
    ],
  }),
  methods: {
    ...mapGetters("pedidos", ["getQtdeTotalKgsPedido"]),
    isMobile() {
      return this.$mq == "sm";
    },
    formatarPercentual(value) {
      return formatPercentual(value);
    },
    formatarMoeda(value, numDec = 2) {
      return formatMoeda(value, numDec);
    },
    classItem(item) {
      return item.somatorio ? "font-weight-bold subtitle-1" : "";
    },
    getItensPedido() {
      var vlrTotDesc = 0;
      var vlrTotFrete = 0;
      var vlrTotItens = 0;

      var itensPedido = [];
      this.novopedido.produtos.forEach((p) => {
        vlrTotDesc += p.valordesconto;
        vlrTotFrete += p.valorliqfrete > 0 ? p.valorliqfrete : p.valorfrete;
        vlrTotItens += p.valortotalitem;
        itensPedido.push(p);
      });

      if (itensPedido.length > 0) {
        itensPedido.push({
          produto: "Totais",
          emb: `${this.getQtdeTotalKgsPedido()} Kgs`,
          valordesconto: vlrTotDesc,
          valorfrete: vlrTotFrete,
          valortotalitem: vlrTotItens,
          somatorio: true,
          erros: [],
        });
      }      

      return itensPedido;
    },
  },
};
</script>

<style>
</style>